/**
 * Returns an array with unique values based on keys provided by the given function.
 */
export const keepUnique = (arr, getKey, keepFirst) => {
    if (keepFirst) {
        let seen = new Set();
        return arr.filter(item => {
            let key = getKey(item);
            return seen.has(key) ? false : seen.add(key);
        });
    }
    return [...new Map(arr.map(x => [getKey(x), x])).values()];
};
